import { GAMEPAD_LANGUAGES } from '~/config/languages';

import styles from './LanguageSelector.module.css';

export type LanguageSelectorProps = {
    /** Currently selected locale code. */
    value: string;
    /** Called with the new locale code when the passenger taps a flag. */
    onChange: (code: string) => void;
};

/**
 * Row of flags shown at first connection (free-play / airport) so each passenger picks
 * their own language. Purely presentational — persistence (localStorage) and i18n
 * switching are done by the caller.
 */
export function LanguageSelector({ value, onChange }: LanguageSelectorProps) {
    return (
        <div className={styles.row} role="group" aria-label="Language">
            {GAMEPAD_LANGUAGES.map((lang) => {
                const selected = lang.code === value;
                return (
                    <button
                        key={lang.code}
                        type="button"
                        className={`${styles.item} ${selected ? styles.selected : ''}`}
                        aria-pressed={selected}
                        onClick={() => onChange(lang.code)}
                    >
                        <span className={styles.flag} aria-hidden>
                            {lang.flag}
                        </span>
                        <span className={styles.label}>{lang.label}</span>
                    </button>
                );
            })}
        </div>
    );
}
